/**
 * Where one step of a process stands on one subject (`<prefix>_step_run.status`).
 *
 * `failed` is retried by the step-retry worker until the attempt limit; `held` is
 * never retried: it waits for a fix (a configuration, a mapping, a parent) and
 * moves on only when the owning process re-runs it.
 */
export enum StepRunStatus {
	PENDING = 'pending',
	RUNNING = 'running',
	SUCCEEDED = 'succeeded',
	FAILED = 'failed',
	HELD = 'held',
	SKIPPED = 'skipped',
}
